import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import { formatSize } from '@sierralabs/core';
const StyledContainer = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #a6a6a6;
  .header {
    display: flex;
    background-color: #1769aa;
    color: #fff;
    justify-content: space-between;
  }
`;
const StyledContent = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #e6e6e6;
  justify-content: center;
  color: #a6a6a6;
  text-align: center;
`;
const UnrenderedFilesViewer = props => {
    const { fileName, fileSize, className } = props;
    return (React.createElement(StyledContainer, { className: className },
        React.createElement("div", { className: 'header' },
            React.createElement(Typography, { variant: 'subtitle2', style: { margin: 10 } }, "File Preview Unavailable"),
            React.createElement(Typography, { variant: 'subtitle2', style: { margin: 10, color: '#a1c1e2' } }, fileName)),
        React.createElement(StyledContent, null,
            React.createElement("div", null,
                React.createElement(Typography, { variant: 'subtitle2', style: { marginBottom: 10, fontSize: 16 } }, fileName),
                React.createElement(Typography, { variant: 'subtitle2', style: { marginBottom: 10, fontSize: 12 } }, formatSize(fileSize || 0))))));
};
export default UnrenderedFilesViewer;
//# sourceMappingURL=UnrenderedFilesViewer.js.map